import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Box, Button, Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { reverse } from 'named-urls'
import { isEmpty } from 'lodash'

import { ConfirmationDialog, LoadingFeedback, MenuButton } from 'components'
import { Table, TableBody, TableCell, TableRow } from 'components/Table'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'
import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'
import helpers from 'helpers'
import { routes } from 'Routes'

import useStyles from './styles'

const FragilitiesTable = ({ fragilities = [], isShow = false, refresh }) => {
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
  const [fragilityToDelete, setFragilityToDelete] = useState(null)
  const [deleting, setDeleting] = useState(false)

  const classes = useStyles()
  const history = useHistory()
  const snackbar = useSnackbar()
  const { companySupplierId } = useThirdPartyManagementStepper()

  const handleRedirect = (companyFragilityId) =>
    history.push(
      reverse(routes.companyFragilities.edit, { companyFragilityId }),
    )

  const handleRequestDelete = (item) => {
    setFragilityToDelete(item)
    setOpenDeleteDialog(true)
  }

  const handleConfirmDelete = async () => {
    try {
      setDeleting(true)
      await service.dponet.suppliers.companyFragilities.destroy({
        companySupplierId,
        companySupplierCompanyFragilityId: fragilityToDelete?.id,
      })

      snackbar.open({
        message: 'Ameaça desvinculada com sucesso',
        variant: 'success',
      })

      refresh()
      setOpenDeleteDialog(false)
      setFragilityToDelete(null)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao desvincular ameaça',
        variant: 'error',
      })
    } finally {
      setDeleting(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={deleting} />
      <Box className={classes.tableContainer}>
        <Table size="small" noWrap>
          <TableBody>
            {!isEmpty(fragilities) ? (
              fragilities.map((item) => (
                <TableRow key={item.id}>
                  <TableCell align="left">
                    <Typography variant="body2">
                      {item.companyFragility?.name}
                    </Typography>
                  </TableCell>
                  {!isShow && (
                    <TableCell align="right">
                      <MenuButton>
                        <Button
                          color="secondary"
                          fullWidth
                          onClick={() => handleRequestDelete(item)}
                        >
                          Desvincular
                        </Button>
                        <Button
                          color="secondary"
                          fullWidth
                          onClick={() =>
                            handleRedirect(item.companyFragility?.id)
                          }
                        >
                          Redirecionar
                        </Button>
                      </MenuButton>
                    </TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2} align="left" className={classes.empty}>
                  <Typography variant="caption">
                    Nenhuma ameaça vinculada.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Box>

      {openDeleteDialog && (
        <ConfirmationDialog
          open={openDeleteDialog}
          setOpen={setOpenDeleteDialog}
          text="Tem certeza que deseja desvincular esta ameaça?"
          textButton="Desvincular"
          actionAcceptButton={handleConfirmDelete}
          loading={deleting}
        />
      )}
    </>
  )
}

FragilitiesTable.propTypes = {
  fragilities: PropTypes.array,
  isShow: PropTypes.bool,
  refresh: PropTypes.func.isRequired,
}

export default FragilitiesTable
